import React, { useContext } from 'react';
import { Card, Alert } from 'antd';
import { WechatOutlined, SmileTwoTone } from '@ant-design/icons';
import Icon from '@ant-design/icons';

import { COMPANY_WECHAT_ID, COMPANY_WORKING_HOURS } from '../../../config';

import AppContext from '../../../components/AppContext';
import PageTitle from '../../../components/PageTitle';

import '../Tutorial/index.css';
const HeartSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
    <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
  </svg>
);

const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

function Contact() {
  const { user, isAuthenticated } = useContext(AppContext);

  return (
    <div className="Tutorial">
      <PageTitle>联系我们</PageTitle>

      <Card bordered={false}>
        <Alert
          type="warning"
          message={`正常工作时间为${COMPANY_WORKING_HOURS}`}
          style={{ marginBottom: '10px' }}
        />
        <div className="Tutorial-content">
          <h4>
            <HeartIcon style={{ color: 'hotpink' }} /> 专属客服
          </h4>

          {isAuthenticated ? (
            <>
              <p>
                你的操作员 {(user.operator || {}).name}{' '}
                同时也是你的专属客服，有任何使用问题都可以通过微信咨询他。若还未添加他的微信，
                请搜索下面的微信号并添加好友：
              </p>
              <p>
                <WechatOutlined />
                &nbsp;&nbsp;{(user.operator || {}).wechatId}
              </p>
            </>
          ) : (
            <p>
              注册成功后，你将拥有自己专属的操作员，他同时也是你的专属客服，有任何使用问题都可以通过微信咨询他
            </p>
          )}
        </div>
        <h4>
          <SmileTwoTone /> 总客服
        </h4>
        <p>注册前有任何问题也可以联系我们的总客服</p>
        <p>
          <WechatOutlined />
          &nbsp;&nbsp;{COMPANY_WECHAT_ID}
        </p>
      </Card>
    </div>
  );
}

export default Contact;
